import { MAX_FILTER_IN_WIDTH } from '../../lib/max-filter-in-width.js';

export const MAX_EVENT_FILTER_IDS = MAX_FILTER_IN_WIDTH;
